import request from '@/utils/request'
import { deepCopy } from '@/utils/index'
import { sift_query_list } from 'utils/sift';

export function login(data) {
  return request({
    // url: '/api/user/login',
    url: `/ocs-auth/user/common/login?account=${data.username}&lang=zh_CN`,
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    // url: '/api/user/info',
    url: '/ocs-auth/user/common/select',
    // url: '/user/manage/select',
    method: 'get',
  })
}

// ! 获取LarkSwitch配置
export function apiPostLarksWitchConfig(data) {
	return request({
		url: '/ocs-project/project/switch/searchBrandLarkSwitchList.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 获取短Token
// export function apiPostSToken(data) {
// 	return request({
// 		url: '/ocs-auth/auth/getSToken',
// 		method: 'post',
// 		data: data
// 	});
// }

// 查询登陆者信息
// export function getInfoSelect(token) {
//   return request({
//     // url: '/api/user/info',
//     url: '/user/manage/select',
//     method: 'get',
//     params: { token }
//   })
// }

//退出登录
export function getLogout() {
  return request({
    url: '/ocs-auth/user/common/logout',
    method: 'post',
  })
}

export function logout(data) {
  return request({
    url: '/ocs-auth/user/common/logout',
    method: 'post',
	data: sift_query_list(data)
  })
}

// 验证码
export function getCode() {
  return request({
    url: '/ocs-auth/user/common/captcha',
    method: 'get'
  })
}

//刷新接口
export function getRefreshCode(data) {
  return request({
    url: '/ocs-auth/auth/refreshToken',
    method: 'post',
    data
  })
}

//用户列表查询接口
export function getManageSel(data) {
  return request({
    url: '/ocs-auth/user/manage/select',
    method: 'post',
    data
  })
}

//品牌列表查询接口
export function getBrandSel(data) {
  return request({
    url: '/ocs-auth/brand/manage/select',
    method: 'post',
    data
  })
}

//查询品牌自定义的菜单
export function getTreeCustom(id) {
  return request({
    url: `/ocs-auth/menu/select/brand/custom/${id}`,
    method: 'get',
  })
}

//菜单管理接口list
export function getMeauCommon() {
  return request({
    url: `/ocs-auth/menu/select/common`,
    method: 'get',
  })
}

//菜单管理接口list 
// 方法不规范，待修改---------------------
export function getUserSave(type,data) {
  return request({
    url: `/ocs-auth/user/manage/${type}`,
    method: 'post',
    data
  })
}
// -------------------------------------

//品牌列表查询接口
export function getBrandSelist(data) {
  return request({
    url: `/ocs-auth/brand/manage/select`,
    method: 'post',
    data
  })
}

//品牌列表查询接口
export function getUserDelm(id) {
  return request({
    url: `/ocs-auth/user/manage/delete/${id}`,
    method: 'post',
  })
}

//品牌列表查询接口 命名不规范待废弃
export function getRoleList(data) {
  return request({
    url: `/ocs-auth/role/select`,
    method: 'post',
    data
  })
}
// 分页查询所有角色
export function roleSelect(data) {
  return request({
    url: `/ocs-auth/role/select`,
    method: 'post',
    data
  })
}

//品牌列表查询接口
export function getBrandCustomAndCommon(id) {
  return request({
    url: `/ocs-auth/menu/select/brand/customAndCommon/${id}`,
    method: 'get',
  })
}

//查询品牌授权的公共菜单
export function menuSelectBrandCommonByBrandId(id) {
  return request({
    url: `/ocs-auth/menu/select/brand/common/${id}`,
    method: 'get',
  })
}

// 查询通用菜单
export function menuSelectCommon() {
  return request({
    url: `/ocs-auth/menu/select/common`,
    method: 'get',
  })
}

// 查询当前用户在所有菜单结构中的权限
export function menuSelectByUserId(id) {
  return request({
    url: `/ocs-auth/menu/select/${id}`,
    method: 'get',
  })
}

// 查询角色当前权限
export function independentMenuSelectByUserId(id) {
  return request({
    url: `/ocs-auth/menu/select/independent/${id}`,
    method: 'get',
  })
}

//品牌列表查询接口
export function getMeauselMenusel(id) {
  return request({
    url: `/ocs-auth/menu/select/brand/customAndCommon/${id}`,
    method: 'get',
  })
}

// 用户管理-更新用户独立授权页面
export function userManageUpdateUserOwnMenuList(data) {
  return request({
    url: `/ocs-auth/user/manage/update/userOwnMenuList`,
    // url: `/ocs-auth/role/update/menu`,
    method: 'post',
    data
  })
}

// updateBrandOwnMenuList 更新品牌菜单授权
export function brandManageUpdateBrandOwnMenuList(data) {
  return request({
    url: `/ocs-auth/brand/manage/update/brandOwnMenuList`,
    method: 'post',
    data
  })
}

// 更新角色-菜单权限
export function roleUpdateMenu(data) {
  return request({
    url: `/ocs-auth/role/update/menu`,
    method: 'post',
    data
  })
}

//livechat 删除接口
export function liveChatDeleteApi(brand,userid) {
  return request({
    url: `/livechat/agent/manager/delete/${brand}/${userid}`,
    method: 'post',
  })
}

//livechat 获取话务员接口
export function liveChatGetApi(brand,userid) {
  return request({
    url: `/livechat/agent/manager/get/${brand}/${userid}`,
    method: 'get',
  })
}

//livechat 更新话务员接口
export function liveChatUpdateApi(brand,data) {
  return request({
    url: `/livechat/agent/manager/update/${brand}`,
    method: 'post',
    data
  })
}

//用户设置头像修改接口
export function personUpdateHeadImg(data) {
  return request({
    url: `/ocs-auth/user/common/update/headImg`,
    method: 'post',
    data
  })
}

//用户设置用户修改密码-登录用户修改自己密码
export function personUpdatePassword(data) {
  return request({
    url: `/ocs-auth/user/common/update/password`,
    method: 'post',
    data
  })
}

// 角色管理-根据用户ID获取当前的角色
export function roleUserRoleByUserId(userId) {
	return request({
		// url: `/ocs-auth/role/userRole/${userId}`,
		url: `/ocs-auth/user/manage/userGroupAndRole/${userId}`,
		method: 'get'
	})
}


// 人员导入接口
export function userMangeImport(data) {
  return request({
    url: `/ocs-auth/user/manage/batch/import`,
    method: 'post',
    data: data
  })
}


// 查询在线用户
export function userCommonOnline(data){
  return request({
    url: `/ocs-auth/user/common/online`,
    method: 'get',
    data: data
  })
}


// 解锁用户
export function userCommonUnlock(userId) {
  return request({
    url: `/ocs-auth/user/common/unlock/${userId}`,
    method: 'get'
  })
}


// 强制签出用户
export function userCommonForceCheckout(userId){
  return request({
    url: `/ocs-auth/user/common/force/checkout/${userId}`,
    method: 'get'
  })
}

// ! 获取群组列表
export function apiPostGroupSelectList(data){
	return request({
		url: `/ocs-auth/group/select`,
		method: 'post',
		data: data
	})
}

// ! 新增群组
export function apiPostGroupSelectAdd(data){
	data = deepCopy(data);
	if(data.groupManagerUserIds) data.groupManagerUserIds = data.groupManagerUserIds.toString();
	return request({
		url: `/ocs-auth/group/save`,
		method: 'post',
		data: data
	})
}

// ! 修改群组
export function apiPostGroupSelectEdit(data){
	data = deepCopy(data);
	if(data.groupManagerUserIds) data.groupManagerUserIds = data.groupManagerUserIds.toString();
	return request({
		url: `/ocs-auth/group/update`,
		method: 'post',
		data: data
	})
}

// ! 删除群组
export function apiGetGroupSelectDelete(groupId){
	return request({
		url: `/ocs-auth/group/delete/${groupId}`,
		method: 'get'
	})
}

// ! 获取群组人员
export function apiPostGroupGetUserList(data){
	return request({
		url: `/ocs-auth/group/get/groupUserList`,
		method: 'post',
		data: data
	})
}

// ! 更新群组人员
export function apiPostGroupUpdateUserList(data){
	return request({
		url: `/ocs-auth/group/update/groupUserList`,
		method: 'post',
		data: data
	})
}

// ! 更新群组人员
export function apiGetGroupList(brand){
	return request({
		url: `/ocs-auth//group/group/brand/${brand}`,
		method: 'get'
	})
}

//----------MFA-------------------------------------------
// 发送验证码或绑定联系方式接口
export function loginSecverifySend(data){
	return request({
		url: `/ocs-auth/user/common/login/secverify/send`,
		method: 'post',
    data
	})
}
// 校验验证码接口（登入)
export function loginSecverifyCheck(data){
	return request({
		url: `/ocs-auth/user/common/login/secverify/check`,
		method: 'post',
    data
	})
}

// 发送验证码接口
export function secverifySend(data){
	return request({
		url: `/ocs-auth/user/common/update/secverify/send`,
		method: 'post',
    data
	})
}
// 更新验证手机，邮箱接口
export function updateSecverifyCheck(data){
	return request({
		url: `/ocs-auth/user/common/update/secverify/check`,
		method: 'post',
    data
	})
}

// 修改手邮 验证码校验
export function commonUpdateContactSecverifysend(data){
	return request({
		url: `/ocs-auth/user/common/update/contact/secverify/send`,
		method: 'post',
    data
	})
}
// 修改手邮 验证码校验
export function commonUpdateSecverifyContact(data){
	return request({
		url: `/ocs-auth/user/common/update/contact`,
		method: 'post',
    data
	})
}

// 修改MFA
export function commonUpdateSecverifyType(data){
	return request({
		url: `/ocs-auth/user/common/update/secverify/type`,
		method: 'post',
    data
	})
}

//-----------------------------------------------------